/**
 * Represents ChipList `Chip` model class.
 */
export class Chip {
}
